// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
/**
 * Copy of the order wizard's step labels, which cannot be read here because the wizard builds its
 * steps from the requisition being edited. portalOrderSteps.test.ts guards against drift.
 */
export const PORTAL_ORDER_STEPS = ['Leistungsort', 'Positionen', 'Zusammenfassung'];
